import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface LegalAgreementsReturn {
  mode: ComputedRef<InputMode>
  label: string
  setAcceptDataProcessingTerms: () => void
}

export const useAcceptDataProcessingTerms = (): LegalAgreementsReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'Each party will only disclose personal data to the other party to process strictly for the Permitted Purpose, namely the hiring process. Applicant confirms that it is entitled to provide Applicant Data to Brighterly for the Permitted Purpose and that all Applicant Data provided to Brighterly is accurate and up to date.'

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && !tutorApplicationStore.form.acceptDataProcessingTerms))

  const setAcceptDataProcessingTerms = (): void => {
    tutorApplicationStore.setField('acceptDataProcessingTerms', !tutorApplicationStore.form.acceptDataProcessingTerms)
  }

  return {
    mode,
    label,
    setAcceptDataProcessingTerms,
  }
}
